/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* New */
window.themeObj = {
  data: {
    shop: 'unepiece-us.myshopify.com'  
  },
  init: function() {
    window.themeObj.templates.collection();

    if (/us.unepiece.com\/en-ca/.test(window.location.href)) {
      window.location.href = 'https://ca.unepiece.com' + window.location.href.replace(/^.*us.unepiece.com\/en-ca(.*)$/, "$1");
    }
  },
  templates: {
    collection: function() {
      const footer = document.querySelector('.boost-pfs-collection-footer');
      const text = document.querySelector('.boost-pfs-collection-footer-text');

      if (footer && text) {
        const textHeight = text.offsetHeight;
        console.log('textHeight', textHeight);

        if (textHeight > 200) {
          footer.classList.add('is-collapsed');

          const textButton = document.querySelector('.boost-pfs-collection-footer-button');
  
          if (textButton) {
            textButton.addEventListener('click', function() {
              footer.classList.remove('is-collapsed');

              const footerLinks = document.querySelector('.Section__FooterLinks');

              if (footerLinks) {
                footerLinks.removeAttribute('style');
              }
            });
          }
        }
      }
    }
  },
  sections: {}
};

window.themeObj.init();
/* /New */